var map = {
	"./img/logo_pravo.png": "bd83",
	"./img/logo_pravo_colored.jpg": "ed89",
	"./img/logo_reg_serv.png": "66fc",
	"./img/logo_reg_serv_colored.jpg": "c22d",
	"./img/speakers/akimov.jpg": "a14f",
	"./img/speakers/avakjan.jpg": "2dc4",
	"./img/speakers/boltenko.jpg": "1c1c",
	"./img/speakers/boltjanskiy.jpg": "baea",
	"./img/speakers/branovitskiy.jpg": "d491",
	"./img/speakers/chervec.jpg": "9555",
	"./img/speakers/domshenko.jpg": "30ef",
	"./img/speakers/eremeev.jpg": "a8da",
	"./img/speakers/grichanin.jpg": "828f",
	"./img/speakers/hvoschinskiy.jpg": "371c",
	"./img/speakers/jagelnickiy.jpg": "6ad2",
	"./img/speakers/lidzhanova.jpg": "849b",
	"./img/speakers/ljubimova.jpg": "aa7c",
	"./img/speakers/no-img.png": "8c6e",
	"./img/speakers/novak.jpg": "77db",
	"./img/speakers/obuhova.jpg": "2df0",
	"./img/speakers/pelevin.jpg": "78ed",
	"./img/speakers/pereladov.jpg": "623d",
	"./img/speakers/pilipenko.jpg": "ef95",
	"./img/speakers/sarapin.jpg": "a672",
	"./img/speakers/shvarc.jpg": "75dd",
	"./img/speakers/solohin.jpg": "6c41",
	"./img/speakers/strebulaev.jpg": "4ed2",
	"./img/speakers/stukalova.jpg": "6730",
	"./img/speakers/tukulov.jpg": "3f29",
	"./img/speakers/vilenskaya.jpg": "1a43",
	"./img/speakers/xodykin.jpg": "5d8c",
	"./img/speakers/yarkov.jpg": "e82d",
	"./img/wave.svg": "d0e0",
	"./scss/_base.scss": "db73",
	"./scss/_btn.scss": "a0b5",
	"./scss/variables.scss": "2295"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";